module.exports = "<section class=\"container-fluid\">\n\n  <div class=\"article-title\">Blank</div>\n\n</section>"